<template>

<app-wrapper :loading="is.loading">

    <app-text>

        <app-group v-html="page.business_adverts_content" />

        <app-group v-if="!adverts.length" :bordered="true">
            
            <app-empty>{{ page.business_adverts_list_empty }}</app-empty>

        </app-group>

        <app-group v-if="adverts.length">

            <div class="list-item" v-for="(advert, index) in adverts" :key="index">

                <div class="list-item-name">{{ advert.name }}</div>
                <div class="list-item-date">{{ advert.start | formatDate('DD/MM/Y') }} - {{ advert.end | formatDate('DD/MM/Y') }}</div>
                <div class="list-item-status" :class="{[classStatus(advert.status)]: true}">{{ textStatus(advert.status) }}</div>

            </div>

        </app-group>

        <app-group :row="true" :center="true">

            <app-button theme="blue" :text="page.business_adverts_list_create" v-on:click="$emit('create')" />

        </app-group>

    </app-text>

</app-wrapper>

</template>

<script>

export default {

    data: function() {

        return {
            is: {
                loading: false
            },
            adverts: []
        }

    },

    created: function() {
      
        this.fetch()
        
    },

    methods: {

        classStatus: function(status) {

            if (status === 1) return 'is-accepted'
            if (status === 2) return 'is-rejected'
            
            return 'is-pending'

        },

        textStatus: function(status) {

            if (status === 1) return 'Accepted'
            if (status === 2) return 'Rejected'
            
            return 'Pending'

        },

        fetch: function() {

            this.is.loading = true

            this.$api.request('account/advverts/list').then(function(json) {

                this.adverts = json.items

                this.is.loading = false

            }.bind(this))

        }

    }

}

</script>

<style scoped>

.list-item {
    border: 1px solid var(--color-grey-light);
    border-bottom-width: 0px;
    padding: 15px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.is-mobile .list-item {
    padding: 10px 10px;
    flex-wrap: wrap;
}

.list-item-name {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: var(--color-grey-dark);
    flex-grow: 1;
}

.is-mobile .list-item-name {
    width: 100%;
}

.list-item-date {
    flex-shrink: 0;
    margin: 0px 20px;
    line-height: 20px;
    font-size: 14px;
    color: var(--color-grey-dark);
    font-weight: 400;
}

.is-mobile .list-item-date {
    font-size: 12px;
    margin: 0px 20px 0px 0px;
    flex-grow: 1;
}

.list-item-status {
    flex-shrink: 0;
    padding: 0px 10px;
    font-size: 14px;
    line-height: 20px;
    color: #fff;
    font-weight: 400;
    border-radius: 4px;
}

.list-item-status.is-pending {
    background-color: var(--color-yellow);
}

.list-item-status.is-accepted {
    background-color: var(--color-green);
}

.list-item-status.is-rejected {
    background-color: var(--color-red);
}

.list-item:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.list-item:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom-width: 1px;
}

</style>